function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { Tooltip } from '@deephaven/components';
import { DOMUtils } from '@deephaven/utils';
import "./CustomFormatAction.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Renders menuElement option with custom format input for use in formatting context menus
 *
 * TODO:
 * - capture focus when this menu action is selected via ArrowUp/ArrowDown keys
 * - dynamically update selected menu item when clicking on the input box
 */
class CustomFormatAction extends Component {
  constructor() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CustomFormatAction.defaultProps;
    super(props);
    _defineProperty(this, "inputRef", void 0);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.inputRef = /*#__PURE__*/React.createRef();
  }
  handleInputChange() {
    var onChange = this.props.onChange;
    if (this.inputRef.current) {
      onChange(this.inputRef.current.value);
    }
  }
  closeContextMenu() {
    var forwardedProps = this.props.forwardedProps;
    var closeMenu = forwardedProps.closeMenu;
    closeMenu(true);
  }
  revertToDefault() {
    var onChange = this.props.onChange;
    onChange(null);
  }
  returnFocusToContextMenu() {
    var parentContextMenu = DOMUtils.getClosestByClassName(this.inputRef.current, 'context-menu-container');
    if (parentContextMenu instanceof HTMLElement) {
      parentContextMenu.focus();
    }
  }
  handleKeyDown(event) {
    switch (event.key) {
      case 'Enter':
        event.stopPropagation();
        this.closeContextMenu();
        break;
      case 'Escape':
        event.stopPropagation();
        this.revertToDefault();
        this.closeContextMenu();
        break;
      case 'ArrowRight':
      case 'ArrowLeft':
        event.stopPropagation();
        break;
      case 'ArrowUp':
      case 'ArrowDown':
        this.returnFocusToContextMenu();
        break;
      default:
        event.stopPropagation();
    }
  }
  render() {
    var _this$props = this.props,
      formatString = _this$props.formatString,
      forwardedProps = _this$props.forwardedProps,
      placeholder = _this$props.placeholder,
      title = _this$props.title;
    var description = forwardedProps.menuItem.description,
      iconElement = forwardedProps.iconElement;
    return /*#__PURE__*/_jsxs("div", {
      className: "form-group flex-grow mb-0",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "custom-format-title",
        children: [/*#__PURE__*/_jsx("span", {
          className: "icon",
          children: iconElement
        }), /*#__PURE__*/_jsxs("label", {
          className: "title mb-0",
          htmlFor: "custom-format-input",
          children: [title, description != null && /*#__PURE__*/_jsx(Tooltip, {
            children: description
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "pl-2 pr-2 pb-2",
        children: /*#__PURE__*/_jsx("input", {
          id: "custom-format-input",
          className: "form-control text-right mb-0",
          type: "text",
          defaultValue: formatString,
          ref: this.inputRef,
          placeholder: placeholder,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleInputChange,
          autoComplete: "off",
          autoCorrect: "off",
          autoCapitalize: "off",
          spellCheck: "false"
        })
      })]
    });
  }
}
_defineProperty(CustomFormatAction, "defaultProps", {
  formatString: '',
  forwardedProps: {
    menuItem: {},
    closeMenu(focusInput) {
      // no-op
    },
    iconElement: null
  },
  placeholder: '',
  title: '',
  onChange(value) {
    // no-op
  }
});
export default CustomFormatAction;
//# sourceMappingURL=CustomFormatAction.js.map